import React from "react";
import { Timer, UserPlus, Wrench, UserX } from "lucide-react";
import { DashboardKpiItem } from "../components/Kpi/types";
import { OperationalInsightItem } from "./salesOperationalInsights";

/**
 * Service Key Operational Insights
 * Layout: 1 row × 4 cards
 */
export const getServiceOperationalInsights = (): DashboardKpiItem[] => [
  {
    id: "avg_job_completion_lead_time",
    label: "Avg Job Completion Lead Time",
    value: "0 days",
    helperLabel: "Average time from service order to job completion",
    icon: React.createElement(Timer, { size: 16 }),
    accentColor: "#2563eb",
    accentBg: "#eff6ff",
  },
  {
    id: "new_customer_added",
    label: "New Customer Added",
    value: 0,
    helperLabel: "New customers created in the selected period",
    icon: React.createElement(UserPlus, { size: 16 }),
    accentColor: "#0f9f6e",
    accentBg: "#ecfdf5",
  },
  {
    id: "jobs_pending_completion",
    label: "Jobs Pending Completion",
    value: 0,
    helperLabel: "Service orders not yet marked Service Completed",
    icon: React.createElement(Wrench, { size: 16 }),
    accentColor: "#e67e22",
    accentBg: "#fff7ed",
  },
  {
    id: "service_customer_inactive_over_1_year",
    label: "Service Customer Inactive Over 1 Year",
    value: 0,
    helperLabel: "Customers with no service order activity for more than 1 year",
    icon: React.createElement(UserX, { size: 16 }),
    accentColor: "#d2363a",
    accentBg: "#fff1f1",
  },
];

export const mergeServiceOperationalInsights = (
  apiItems?: OperationalInsightItem[],
): DashboardKpiItem[] => {
  const apiItemsById = new Map((apiItems || []).map((item) => [item.id, item]));

  return getServiceOperationalInsights().map((item) => {
    const apiItem = apiItemsById.get(item.id);
    if (!apiItem) return item;

    return {
      ...item,
      label: apiItem.label || item.label,
      value: apiItem.value ?? item.value,
      helperLabel: apiItem.helperLabel || item.helperLabel,
    };
  });
};
